<template>
  <div class="mainsection">
    <div class="container maincontent d-flex">
      <div class="flex-column align-self-end">
        <h1>Precision.</h1>
        <h1>Prepress.</h1>
        <h1>Technology.</h1>
        <p>Delivering exceptional quality, accuracy and support to the corrugated + flexible packaging industry.</p>
        <b-button variant="accent" size="lg" @click.prevent="jumpTo(cta)">Learn More</b-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "hero",
  inject: ["jumpTo"],
  data: function () {
    return {
      cta: "services"
    }
  }
}
</script>

<style lang="scss">
.mainsection {
  height: 825px;
  background: url('~@/assets/lusher-main-2560.jpg') no-repeat top center;
  //background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('~@/assets/lusher-color-2560.jpg') no-repeat top center;
  background-color: #000000;
  background-size: 2560px;

  @media screen and (max-width: 1000px) {
    height: 500px;
    background-size: 1200px;
  }

  @media screen and (max-width: 900px) {
    height: 800px;
    background-size: 1920px;
  }

  @media screen and (max-width: 775px) {
    height: 500px;
    background-color: black;
  }

  .maincontent{
    height: 92%;

    h1 {
      font-size: 66px;
      line-height: 0.75;
      text-shadow: 4px 2px 15px #000;
      letter-spacing: -2px;
      text-transform: uppercase;
      color: #ffffff;

      @media screen and (max-width: 900px) {
        font-size: 48px;
      }
    }

    p {
      color: #ffffff;
      max-width: 425px;
    }
  }


}
</style>